import axios from "axios";
import { connect } from "react-redux";
import React, { useState, useRef, useEffect } from "react";
import EventLabel2, { init } from "../../components/EventLabel2/EventLabel2";
import { combineProps } from "../../helpers/objectHelper";
import PersonRoundedIcon from "@material-ui/icons/PersonRounded";
import { eventLabelGroupsConstants } from "../constants/eventLabelGroups.contansts";
import { List, ListItem, ListItemAvatar, ListItemText } from "@material-ui/core";

const DEFAULT_SPEAKER = {
  profileImage: "https://talk.nordea.se/privatebanking/wp-content/uploads/2020/01/elon-musk-royal-society-av-duncan-hull.jpg",
  name: "Elon Musk",
  company: "Tesla",
  title: "CEO",
};

const SpeakerCard = (props) => {
  const [agenda, setAgenda] = useState([]);
  const [speakers, setSpeakers] = useState([]);
  const [activeSpeaker, setActiveSpeaker] = useState(null);
  const [floorIsGive, setFloorIsGiven] = useState(false);
  const { eventId, clientKey, lang, connected, hubConnection, noneAllowedSpeakers, personTypes, template, companyName, clientName, preview, settings } = props;

  const { requestedEventId, getAgendaFromOtherEvent } = settings;

  useEffect(() => {
    init(eventId, eventLabelGroupsConstants.SPEAKER_CARD_LABEL_GROUP, lang);
    if (!preview) {
      fetchSpeakers();
      fetchAgenda();
      configureHubEvents();
    }
  }, []);

  const fetchAgenda = () => {
    axios
      .get(`./api/meeting/agenda/${getAgendaFromOtherEvent && requestedEventId ? requestedEventId : eventId}`)
      .then(({ data }) => {
        if (!data) return;
        const agendaItems = data.sort(function (a, b) {
          return a.sortOrder - b.sortOrder;
        });
        setAgenda(agendaItems);
      })
      .catch((err) => {
        console.error(err);
      });
  };
  const configureHubEvents = () => {
    if (hubConnection) {
      hubConnection.on("onSpeakersUpdate", (speakers) => setSpeakers(speakers));
      hubConnection.on("onActivateSpeaker", (activeSpeaker) => {
        setActiveSpeaker(activeSpeaker);
      });
      hubConnection.on("onDeactivateSpeaker", () => setActiveSpeaker(null));
      hubConnection.on("onAgendaUpdate", (agenda) => {
        setAgenda(agenda);
      });
      hubConnection.on("onAgendaClosed", (speakers) => {
        setSpeakers(speakers);
        setActiveSpeaker(null);
      });
    }
  };

  const fetchSpeakers = () => {
    axios
      .get(`./api/meeting/speakers/${eventId}`)
      .then(({ data }) => {
        if (data) {
          setSpeakers(data);
          const active = data.find((a) => a.active == true);
          if (active) {
            const speaker = props.orderList.find((ol) => ol.badgeNo == active.badgeNo);
            setActiveSpeaker(speaker);
          }
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const api = {
    speakers,
    agenda,
    ...props,
    activeSpeaker: preview ? DEFAULT_SPEAKER : activeSpeaker,
    activeAgenda: agenda.find((a) => a.active == true),
    speakers,
  };

  return <ActiveSpeaker {...api} />;
};

const ActiveSpeaker = (props) => {
  const { template, activeSpeaker, settings, orderList, preview, speakers } = props;
  const { fontFamily, fontSize, color, fontWeight, background, imageBorderColor, imageSize, imageBorderWidth, containerBorderWidth, containerBorderColor } = settings;

  if (!activeSpeaker) return null;

  const { name, title, company, profileImage } = activeSpeaker;
  const speakerLabel = `${name}${title ? ", " + title : ""}${company ? ", " + company : ""}`;

  return (
    <List className="smooth-shadow slide-fade" style={{ padding: 0 }}>
      <ListItem style={{ background, padding: "0px 16px", borderBottomLeftRadius: "35px", borderTopLeftRadius: "35px", border: `${containerBorderWidth} solid ${containerBorderColor}` }}>
        <ListItemAvatar style={{ position: "relative" }}>
          <div
            className="image-container"
            style={{
              width: imageSize,
              height: imageSize,
              
            }}
          >
            <div
              style={{
                backgroundImage:
                  !preview && orderList.find((o) => o.badgeNo == activeSpeaker.badgeNo)?.profileImage ? `url('${orderList.find((o) => o.badgeNo == activeSpeaker.badgeNo)?.profileImage}')` : undefined,
                backgroundPosition: "center",
                backgroundSize: "cover",
                border: `${imageBorderWidth} solid ${imageBorderColor}`,
                width: imageSize,
                height: imageSize,
              }}
            >
              {!preview && orderList.find((o) => o.badgeNo == activeSpeaker.badgeNo)?.profileImage ? null : <PersonRoundedIcon style={{ fontSize: `calc(${imageSize} / 3)` }} />}
            </div>
          </div>
        </ListItemAvatar>
        <ListItemText
          style={{ marginLeft: -20, marginTop: 0, marginBottom: 0 }}
          secondaryTypographyProps={{
            className: "ellipsis",
            style: {
              color,
              maxWidth: "100%",
            },
          }}
          primary={
            <span style={{ fontFamily, fontSize, color, fontWeight }} className="ellipsis">
              <EventLabel2 name="CurrentSpeaker" groupName="DigitalMeeting.SpeakerCard" />
            </span>
          }
          secondary={<span style={{ fontFamily, fontSize, color, fontWeight }}>{speakerLabel}</span>}
        />
      </ListItem>
    </List>
  );
};

function mapStateToProps(state) {
  return {
    template: state.template.template ? state.template.template.content : null,
  };
}
export default connect(mapStateToProps)(SpeakerCard);
